<template>
  <v-dialog v-model="open" max-width="800px" persistent>
    <v-card class="rounded-xl" style="background-color: rgb(var(--v-theme-surface));">
      <v-card-text>
        <div class="d-flex flex-row align-center justify-space-between w-100">
          <h3 style="color:rgb(var(--v-theme-primary))" >{{registerMode ? 'Créer un compte' : 'Se connecter'}}</h3>
          <v-btn color="primary" icon variant="plain"><v-icon size="32" @click="close">mdi-close</v-icon></v-btn>
        </div>

        <template v-if="!registerMode">
          <v-alert type="red" variant="tonal" v-if="error">{{errorMessage}}</v-alert>
          
          <div class="mt-5">
            <v-text-field type="text" base-color="primary" color="primary" style="color:rgb(var(--v-theme-primary))" variant="underlined" label="Nom d'utilisateur" v-model="username"></v-text-field>
            <v-text-field type="password" base-color="primary" color="primary" style="color:rgb(var(--v-theme-primary))" variant="underlined" label="Mot de passe" v-model="passwordA"></v-text-field>
            
            <div class="d-flex flex-column justify-center align-center">
              <v-btn color="warning" variant="plain" @click="changeRegisterMode"><h6>Je n'ai pas de compte</h6></v-btn>
              <v-btn color="primary" class="mt-5" variant="plain" @click="login"><h3>Se connecter</h3></v-btn>
            </div>
          </div>
        </template>
        <template v-else>
          <v-alert type="red" variant="tonal" v-if="error">{{errorMessage}}</v-alert>
          
          <div class="mt-5">
            <v-text-field type="text" base-color="primary" color="primary" style="color:rgb(var(--v-theme-primary))" variant="underlined" label="Nom d'utilisateur" v-model="username"></v-text-field>
            <v-text-field type="password" base-color="primary" color="primary" style="color:rgb(var(--v-theme-primary))" variant="underlined" label="Mot de passe" v-model="passwordA"></v-text-field>
            <v-text-field type="password" base-color="primary" color="primary" style="color:rgb(var(--v-theme-primary))" variant="underlined" label="Mot de passe" v-model="passwordB"></v-text-field>
            
            <div class="d-flex flex-column justify-center align-center">
              <v-btn color="warning" variant="plain" @click="changeRegisterMode"><h6>J'ai déjà un compte</h6></v-btn>
              <v-btn color="primary" class="mt-5" variant="plain" @click="register"><h3>Valider</h3></v-btn>
            </div>
          </div>
        </template>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword } from "firebase/auth"

import Profile from "@/classes/Profile.js"

  export default {
    props: ["modelValue"],
    data() {
      return {
        open: false,
        registerMode: false,
        username: "",
        passwordA: "",
        passwordB: "",
        error: false,
        errorMessage: "",
      }
    },
    watch: {
      modelValue(newValue) {
        this.open = newValue
        this.username = ""
        this.passwordA = ""
        this.passwordB = "",
        this.error = false
        this.errorMessage = ""
      },
      open(newValue) {
        this.$emit('update:modelValue', newValue)
        this.username = ""
        this.passwordA = ""
        this.passwordB = "",
        this.error = false
        this.errorMessage = ""
      }
    },
    methods: {
      changeRegisterMode() {
        this.registerMode = !this.registerMode
        this.error = false
        this.errorMessage = ""
        this.username = ""
        this.passwordA = ""
        this.passwordB = ""
      },
      login() {
        const auth = getAuth()
        signInWithEmailAndPassword(auth, this.username+'@leatvprod.com', this.passwordA)
          .then((userCredential) => {
            // Signed in
            const user = userCredential.user
            this.$emit('login', user)
            this.open = false
          })
          .catch((error) => {
            const errorCode = error.code
            const errorMessage = error.message
            this.error = true
            this.errorMessage = errorMessage
          })
      },
      async register() {
        if(await this.checkIfUsernameAvailable(this.username)){
          if(this.passwordA !== this.passwordB) {
            this.error = true
            this.errorMessage = "Les mots de passe ne correspondent pas"
            return
          }
          if(this.username.length < 3) {
            this.error = true
            this.errorMessage = "Le nom d'utilisateur doit faire au moins 3 caractères"
            return
          }
          if(this.passwordA.length < 6) {
            this.error = true
            this.errorMessage = "Le mot de passe doit faire au moins 6 caractères"
            return
          }

          createUserWithEmailAndPassword(getAuth(), this.username + "@leatvprod.com", this.passwordA)
          .then(async (userCredential) => {
            const user = userCredential.user
            let newProfile = new Profile(user.uid, this.username, "user", new Date().getTime(), {theme: 'dark', starsEnabled: false}, null)
            await newProfile.save()
          
            this.$emit('login', user)
            this.registerMode = false
            this.open = false
          })
          .catch((error) => {
            console.log(error)
          })
        }
      },
      async checkIfUsernameAvailable(username) {
        let profile = await Profile.getByUsername(username)
        if (profile && profile.length > 0) {
          console.log(profile)
          this.error = true
          this.errorMessage = "Ce nom d'utilisateur existe déjà"
          return false
        } else {
          this.error = false
          this.errorMessage = ""
          return true
        }
      },
      close() {
        this.open = false
      },
    },
  }
</script>


